<template>
    <div id="activity">
        <Banner title="學術活動" :breadcrumbs="breadcrumbs" type="activity"></Banner>
        <div class="container">
            <div class="center_title">
                <Title :en="titleEn" :chtFirst="titleF" :chtSecond="titleB" :center="true"></Title>
            </div>
            <section class="content" v-if="!eventId">
                <ul class="categrory">
                    <li
                        v-for="(item,index) in categrory"
                        :key="index"
                        :class="{'active':item.Name == choose}"
                        @click="chageTab(item.Name,item.Id)"
                    >{{item.Name}}</li>
                </ul>
                <div
                    class="list"
                    v-infinite-scroll="loadMore"
                    infinite-scroll-disabled="busy"
                    infinite-scroll-distance="10"
                    v-show="events.length > 0"
                >
                    <LsitCard
                        v-for="(event,index) in events"
                        :key="event.Id"
                        :event="event"
                        :categoryList="categrory"
                    ></LsitCard>
                </div>
                <notfound v-if="events.length == 0" info="目前尚未有活動，"></notfound>
            </section>
            <section v-if="eventId">
                <div class="detail">
                    <h3 class="title">{{eventDetail.Title}}</h3>
                    <div class="info">
                        <!-- <div class="date">
                            <i class="icon icon-calendar"></i>
                            {{$moment(eventDetail.StartOn).format("LL") + "~" + $moment(eventDetail.EndOn).format("LL") }}
                        </div> -->
                        <div class="date">
                            <i class="icon icon-calendar"></i>
                            {{$moment(eventDetail.RegisterStartOn).format("LL") + "~" + $moment(eventDetail.RegisterEndOn).format("LL") }}
                        </div>
                        <div class="place">
                            <i class="icon icon-place"></i>
                            {{eventDetail.Location}}
                        </div>
                    </div>
                    <ul class="table">
                        <li v-if="eventDetail.Organizer">
                            <div class="subtitle">主辦單位</div>
                            <div
                                class="subcontent"
                            >{{eventDetail.Organizer ? eventDetail.Organizer : '無'}}</div>
                        </li>
                        <li v-if="eventDetail.CoOrganizer">
                            <div class="subtitle">協辦單位</div>
                            <div
                                class="subcontent"
                            >{{eventDetail.CoOrganizer ? eventDetail.CoOrganizer : '無'}}</div>
                        </li>
                        <li v-if="eventDetail.DocumentFile">
                            <div class="subtitle">檔案下載</div>
                            <a
                                href="javascript:;"
                                class="subcontent"
                                @click="download(eventDetail.DocumentFile)"
                            >{{eventDetail.DocumentFile?"下載(節目表)":"無"}}</a>
                        </li>
                    </ul>
                    <div class="remark">
                        <div
                            class="one"
                            v-if="!eventDetail.RequirePayment && eventDetail.RequireRegister"
                        >※ 免費參加，因座位有限，請事先報名，滿額為止。</div>
                    </div>
                    <div class="event_content" v-html="eventDetail.Content"></div>
                    <div class="contact">
                        <div class="title">聯絡資訊</div>
                        <ul class="info">
                            <li>聯絡人:潘柔竹</li>
                            <li>
                                電子信箱:
                                <a href="javascript:void(0)">twrs.tw@gmail.com</a>
                            </li>
                            <li>聯絡電話:0965-106-869</li>
                        </ul>
                    </div>
                    <div class="join" v-if="eventDetail.RequireRegister">
                        <a class="Orange_btn islogin" :href="`/Event/Index?Id=${eventDetail.Id}`">
                            <span>活動報名</span>
                        </a>
                    </div>
                </div>
                <graybtn name="回上一頁" url="back" />
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import LsitCard from "@/components/listCard";
import API from "@/service/activity";
import Common from "@/common";
export default {
    name: "activity",
    components: {
        LsitCard
    },
    props: ["activities"],
    data() {
        return {
            //麵包削
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "學術活動"
                },
                {
                    url: "/Academic/Activity",
                    title: "學術活動"
                }
            ],
            //分類列表
            categrory: [],
            //分類選擇
            choose: "全部",
            //全部活動(dev)
            events: [],
            CategoryId: "",
            Page: 1,
            Count: 10,
            Totalpage: 1,
            busy: false,
            //網址參數 活動ID
            eventId: "",
            titleF: "活動",
            titleB: "列表",
            titleEn: "Event List",
            eventDetail: [],
            TitleType: "",
            isLoading: false,
            isListEmptry:false
        };
    },
    methods: {
        chageTab(e, Id) {
            const vm = this;
            vm.choose = e;
            vm.CategoryId = Id;
            vm.events = [];
            API.getActivityList({
                page: 1,
                count: vm.Count,
                id: vm.CategoryId
            }).then(res => {
                if (res.Ok) {
                    vm.events = res.Data.Activities;
                    vm.Page = 1;
                    vm.Totalpage = Math.ceil(
                        parseInt(res.Data.Total) / vm.Count
                    );
                }
            });
        },
        loadMore() {
            const vm = this;
            if(!vm.isListEmptry){
                vm.busy = true;
                if (vm.Totalpage == vm.Page) {
                    return false;
                }
                vm.Page += 1;
                vm.isLoading = true;
                let params = {};
                if (vm.choose == "全部") {
                    params = {
                        page: vm.Page,
                        count: vm.Count
                    };
                } else {
                    params = {
                        page: vm.Page,
                        count: vm.Count,
                        id: vm.CategoryId
                    };
                }
                API.getActivityList(params).then(res => {
                    if (res.Ok) {
                        if(res.Data.Activities.length == 0){
                            vm.isListEmptry = true;
                        } else {
                            vm.events = vm.events.concat(res.Data.Activities);
                            setTimeout(function() {
                                vm.busy = false;
                            }, 1000);
                        }
                    }
                    setTimeout(function() {
                        vm.isLoading = false;
                    }, 500);
                });
            }
        },
        back() {
            location.href = "/Academic/Activity";
        },
        download(url) {
            const vm = this;
            let Type = url
                .split("/")
                .pop()
                .split(".")
                .pop();
            Common.download(url, { type: Type });
        }
    },
    computed: {},
    created() {
        const vm = this;
        let Urlparams = Common.GetUrlParams("Id");
        vm.eventId = Urlparams;

        if (process.env.NODE_ENV === "production") {
            //獲取活動分類項目
            API.getActivityCategory().then(res => {
                if (res.Ok) {
                    let arr = [
                        {
                            Id: "",
                            Name: "全部",
                            Title: "全部"
                        }
                    ];
                    // console.log(res.Data);
                    vm.categrory = arr.concat(res.Data);
                    let obj = JSON.parse(vm.activities);
                    vm.events = obj.Activities;
                    vm.Totalpage = Math.ceil(parseInt(obj.Total) / vm.Count);
                    vm.busy = false;
                }
            });
            if (vm.eventId) {
                API.getActivityDetail({ Id: vm.eventId }).then(result => {
                    if (result.Ok) {
                        vm.eventDetail = result.Data;
                        vm.categrory.forEach(item => {
                            if (item.Id == vm.eventDetail.CategoryId) {
                                vm.TitleType = item.Title;
                            }
                        });
                    } else {
                        location.href = "/Academic/Activity";
                    }
                });
            }
        } else {
            vm.categrory = [
                {
                    Id: "",
                    Name: "全部",
                    Title: "全部"
                },
                {
                    Id: "bb941e83-cedd-4bc1-b2a2-127688844b49",
                    Name: "國外活動",
                    Title: "International"
                },
                {
                    Id: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                    Name: "國內活動",
                    Title: "Domestic"
                },
                {
                    Id: "9c6e32c0-1ed6-44c4-bd0d-ed5e9a949ade",
                    Name: "年會",
                    Title: "Annual_meeting"
                },
                {
                    Id: "172a1a46-596a-4c07-8ba9-51b6a778c97d",
                    Name: "地會",
                    Title: "Mid_meeting"
                }
            ];
            vm.events = [
                // {
                //     Id: "9acaddasdhhyth",
                //     Type: "International",
                //     Image: require("@/assets/dev/img1.png"),
                //     CategoryId: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                //     Title: "APAO 2019",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Location: "Bangkok Thailand",
                //     Organizer: "哈哈"
                // },
                // {
                //     Id: "134dfy56yyuk",
                //     Type: "Domestic",
                //     Image: require("@/assets/dev/img2.png"),
                //     CategoryId: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                //     Title: "視網膜學會108年第一次<南區>醫師繼續教育",
                //     Date: "2019-03-01 ~ 2019-03-02",
                //     StartTime: "1551369600",
                //     Location: "高雄長坑紀念醫院-湖畔星光1樓星光聽",
                //     Organizer: "哈哈"
                // },
                // {
                //     Id: "1231sdfs756887i",
                //     Type: "Annual",
                //     Image: require("@/assets/dev/img3.png"),
                //     CategoryId: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                //     Title: "第59次年度學術研討會",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Location: "台大醫院國際會議中心",
                //     Organizer: "中華民國眼科醫學會"
                // },
                // {
                //     Id: "123sdfsdfrt",
                //     Type: "Mid",
                //     Image: require("@/assets/dev/img2.png"),
                //     CategoryId: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                //     Title: "第54次學術研討會",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Location: "台南大億麗緻酒店",
                //     Organizer: "中台南奇美醫院永康院區眼科部"
                // },
                // {
                //     Id: "12f567usdfsa",
                //     Type: "International",
                //     Image: require("@/assets/dev/img3.png"),
                //     CategoryId: "e3ca867b-e423-4632-b7b5-f8e361d73f7e",
                //     Title: "APAO 2019",
                //     Date: "2019-03-01",
                //     StartTime: "1551369600",
                //     Location: "Bangkok Thailand",
                //     Organizer: "中華民國眼科醫學會"
                // }
            ];
        }
        switch (vm.TitleType) {
            case "Annual_meeting":
                vm.titleEn = "Annual Meetings";
                vm.titleF = "年";
                vm.titleB = "會";
                break;
            case "Mid_meeting":
                vm.titleEn = "Mid-Year Meetings";
                vm.titleF = "地";
                vm.titleB = "會";
                break;
            case "International":
                vm.titleEn = '"International Activities"';
                vm.titleF = "國外";
                vm.titleB = "活動";
                break;
            case "Domestic":
                vm.titleEn = "Domestic Activie";
                vm.titleF = "國內";
                vm.titleB = "活動";
                break;
        }
        //END
    },
    mounted() {},
    watch: {}
};
</script>

<style scoped>
#activity .categrory {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    justify-content: center;
    margin-bottom: 20px;
}
#activity .categrory li {
    padding: 0 15px;
    cursor: pointer;
    text-align: center;
    min-width: 120px;
}
#activity .categrory li + li {
    border-left: 1px solid #666;
}
#activity .categrory li.active {
    color: #ee8b59;
}
#activity .content {
    margin: 0 auto 60px;
}
#activity .list {
    background-color: #eee;
    padding: 20px 10px;
    min-height: 300px;
}
#activity .detail {
    padding: 40px;
    border: 8px solid #eee;
    margin-bottom: 30px;
    background-color: #fff;
    color: #666;
}
#activity .detail .title,
#activity .detail .info,
#activity .detail .table,
#activity .detail .remark {
    line-height: 1.5;
    letter-spacing: 2px;
    padding: 10px 15px;
    border-bottom: 1px solid #ddd;
}
#activity .detail .title {
    font-size: 1.75rem;
    color: #333;
    line-height: 1.5;
}
#activity .detail .info > div {
    padding: 4px 0;
}
#activity .detail .table {
    border: none;
}
#activity .detail .table li {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 8px;
}
#activity .detail .table li .subtitle {
    background-color: #eee;
    padding: 16px 24px;
    margin-right: 15px;
}
#activity .detail .table li .subcontent {
    padding: 16px 20px;
    border-bottom: 1px solid #eee;
    flex: 1;
    display: block;
    text-decoration: none;
    color: #666;
}
#activity .detail .remark {
    border: none;
}
#activity .detail .remark > div {
    padding: 16px 0;
}
#activity .detail .event_content {
    color: #666;
    line-height: 1.5;
    letter-spacing: 2px;
    padding: 30px 10px;
}
#activity .detail .event_content >>> p {
    color: #666;
    line-height: 1.5;
    letter-spacing: 2px;
}
#activity .detail .event_content >>> img {
    max-width: 100%;
}
#activity .detail .contact .title {
    color: #ee8b59;
    margin-bottom: 30px;
}
#activity .detail .contact .info {
    padding: 0 15px;
    border: none;
}
#activity .detail .contact .info li {
    padding: 8px 0;
}
#activity .detail .contact .info li > a {
    color: #29abe2;
}
#activity .detail .join {
    max-width: 165px;
    margin-top: 30px;
}
@media screen and (max-width: 767px) {
    #activity .categrory {
        width: 100%;
    }
    #activity .categrory:after {
        content: "";
        flex: 1;
    }
    #activity .categrory li {
        /* flex-grow: 1; */
        padding: 5px;
        width: 50%;
        margin-bottom: 20px;
    }
    #activity .categrory li:nth-child(odd) {
        border: 0;
    }
    #activity .categrory li:last-child {
        border: 0;
    }
    #activity .list {
        background-color: #eee;
        padding: 20px 5px 5px 5px;
        margin-bottom: 20px;
    }
    #activity .detail {
        padding: 20px 10px;
    }
    #activity .detail .table,
    #activity .detail .title {
        padding: 10px 0;
    }

    #activity .detail .event_content {
        padding: 30px 0;
    }
    #activity .detail .table li .subtitle {
        width: 100%;
        text-align: center;
        margin-right: 0;
    }
    #activity .detail .table li .subcontent {
        width: 100%;
        text-align: center;
    }
    #activity .detail .contact .info li {
        width: 100%;
    }
    #activity .detail .join {
        margin: 40px auto 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity.vue